import { gsap } from 'gsap';

const selectors = {
  el: '.js-mouse-move:not(.is-initialized)',
  item: '.js-mouse-move-el',
};

const init = () => {
  const els = document.querySelectorAll(selectors.el);
  els.forEach(el => {
    el.classList.add('is-initialized');
    const items = el.querySelectorAll(selectors.item);

    el.addEventListener('mousemove', e => {
      items.forEach(item => {
        const rect = item.getBoundingClientRect();
        const targetX = e.clientX - rect.left + 'px';
        const targetY = e.clientY - rect.top + 'px';
        gsap.set(item, {
          '--x': targetX,
          '--y': targetY,
        });
      });
    });
  });
};

const module = () => {
  init();
  document.addEventListener('domUpdated', init);
};

export default module;
